import { ref, computed } from 'vue';

// Pastilles de filtre partagées entre MesActions.vue (client) et
// SuiviAnalyseConseiller.vue (conseiller) : les deux affichent la même liste
// d'actions de suivi (statut + échéance + en_retard) avec les mêmes 4 vues.
export const ACTIONS_STATUS_FILTERS = [
  { value: 'all', label: 'Tous' },
  { value: 'en_cours', label: 'A faire' },
  { value: 'termines', label: 'Terminés' },
  { value: 'en_retard', label: 'En retard' },
];

// `getItems` est une fonction (pas un ref) pour rester utilisable aussi bien
// avec une source plate (`() => todoActions.value`) qu'imbriquée
// (`() => dossier.value?.actions || []`), sans imposer la forme du state
// appelant.
export function useActionsFilter(getItems) {
  const search = ref('');
  const activeFilter = ref('all');

  function setFilter(value) {
    activeFilter.value = value;
  }

  const counts = computed(() => {
    const all = getItems() || [];
    return {
      all: all.length,
      en_cours: all.filter((a) => a.statut !== 'terminee').length,
      termines: all.filter((a) => a.statut === 'terminee').length,
      en_retard: all.filter((a) => a.en_retard).length,
    };
  });

  const filteredActions = computed(() => {
    let list = getItems() || [];
    if (activeFilter.value === 'en_cours') list = list.filter((a) => a.statut !== 'terminee');
    else if (activeFilter.value === 'termines') list = list.filter((a) => a.statut === 'terminee');
    else if (activeFilter.value === 'en_retard') list = list.filter((a) => a.en_retard);

    const q = search.value.trim().toLowerCase();
    if (!q) return list;
    return list.filter((a) => (a.description || '').toLowerCase().includes(q));
  });

  return { search, activeFilter, setFilter, counts, filteredActions };
}
